import axios from "@/app/Axios";

class Reportes {
    async busquedagradofuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportepersonalfuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedaresarcimientofuerza(id,id2,id3) {
        try {
            const response = await axios.get(`/reportes/reporteresarcimientosfuerza/${id}/${id2}/${id3}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedareposicionesfuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportereposicionesfuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedapistolafuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportepistolagradofuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedacuchillofuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportecuchillogradofuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedasablesfuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportesablesgradofuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }

    async buscarPorFechas(fechaInicio, fechaFin) {
        try {
          const response = await axios.get('/reportes/buscar-por-fechas', {
            params: {
              fecha_inicio: fechaInicio,
              fecha_fin: fechaFin
            }
          });
          return response.data;
        } catch (error) {
          console.error("Error al buscar por fechas:", error);
          throw error;
        }
      }
async buscarPorFechasPistolas(fechaInicio, fechaFin) {
    try {
      const response = await axios.get('/reportes/buscar-por-fechasPistolas', {
        params: {
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error al buscar por fechas:", error);
      throw error;
    }
  }
  async buscarPorFechasArmamento(fechaInicio, fechaFin) {
    try {
      const response = await axios.get('/reportes/buscar-por-fechasArmamento', {
        params: {
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error al buscar por fechas:", error);
      throw error;
    }
  }
}
export default Reportes;
